module.exports = __webpack_public_path__ + "img/book_bean_img.181aa7f7.png";